export enum AppointmentCandidateStatus {
  open = 'open',
}
